import { render, staticRenderFns } from "./HowItWorks.vue?vue&type=template&id=d199b88a&scoped=true&"
import script from "./HowItWorks.js?vue&type=script&lang=js&"
export * from "./HowItWorks.js?vue&type=script&lang=js&"
import style0 from "./HowItWorks.scss?vue&type=style&index=0&id=d199b88a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d199b88a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCol,VIcon})
